import { render } from "./QuestionsLists.vue?vue&type=template&id=61010aae"
import script from "./QuestionsLists.vue?vue&type=script&lang=js"
export * from "./QuestionsLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__